import { GravyBinder } from "gravy-bind";
import { MDCLinearProgress } from '@material/linear-progress';
import { PaperlessService } from "../services/paperless.service";

export class PaperlessPreference {
    public static cssClass = "paperless-preference";
    private binder: GravyBinder;
    private rootElement: HTMLFormElement;
    public isSaving: boolean;
    public isSaveComplete: boolean = false;
    private loader: MDCLinearProgress;
    public isPaperless: boolean = false;
    private service: PaperlessService = new PaperlessService();

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement as HTMLFormElement;
        this.initialize()
    };

    private initialize = async (): Promise<void> => {
        this.bindEvents();
        this.binder = new GravyBinder(this, this.rootElement);
        this.loader = new MDCLinearProgress(this.rootElement.querySelector('.mdc-linear-progress'));
        this.loader.determinate = false;
        this.loader.open();

        this.isPaperless = await this.service.getPreference();
        this.binder.updateOutwardBindings();

        this.binder.updateBindings();
        this.loader.close();
    };

    private bindEvents = (): void => {
        this.rootElement.addEventListener('submit', event => {
            event.preventDefault();
            this.changePreference();
        });

    };

    public changePreference = async (): Promise<void> => {
        this.loader.open();

        this.isPaperless = !this.isPaperless;
        await this.service.setPreference(this.isPaperless);

        this.loader.close();
        this.isSaveComplete = true;
        this.binder.updateOutwardBindings();
    };
}